/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect } from "react";
import useTranslate from "hooks/useTranslate";
import useSnackbar from "hooks/useSnackbar";

const useSnackbarSuccess = (data?: { message?: string }) => {
  const translate = useTranslate();
  const snackbar = useSnackbar();

  useEffect(() => {
    if (data) {
      snackbar("success", data?.message || translate("success:default"));
    }
  }, [data]);
};

export default useSnackbarSuccess;
